import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { NavItemModel, NavItemTranslateCodes } from '@core/models/nav-item.model';
import { SettingsAsObject } from '@core/models/settings.model';
import { NavItemAccessPipe } from '@core/pipes/nav-item-access.pipe';
import { RouteEntity } from '@core/router/router.entity';
import { AppState } from '@core/state/app.state';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';


@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-burger-menu-modal',
    templateUrl: './burger-menu-modal.component.html',
    styleUrls: ['./burger-menu-modal.component.scss'],
    imports: [
        MatIconModule,
        MatButtonModule,
        MatDialogModule,
        NavItemAccessPipe,
        TranslateModule,
        MatFormFieldModule,
        AsyncPipe,
    ],
})
export class BurgerMenuModalComponent {
    public static readonly DIALOG_ID: string = 'BurgerMenuModalComponent';

    readonly #appState: AppState = inject(AppState);
    readonly #dialog: MatDialog = inject(MatDialog);

    public readonly settings$: Observable<SettingsAsObject> = this.#appState.settings$;

    public readonly navItemList: NavItemModel[] = [
        {
            path: [RouteEntity.Root, RouteEntity.Tickets],
            title: NavItemTranslateCodes.get(RouteEntity.Tickets),
        },
        {
            path: [RouteEntity.Root, RouteEntity.Services],
            title: NavItemTranslateCodes.get(RouteEntity.Services),
        },
        {
            path: [RouteEntity.Root, RouteEntity.History],
            title: NavItemTranslateCodes.get(RouteEntity.History),
        },
        {
            path: [RouteEntity.Root, RouteEntity.Person],
            title: NavItemTranslateCodes.get(RouteEntity.Person),
        },
        {
            path: [RouteEntity.Root, RouteEntity.Map],
            title: NavItemTranslateCodes.get(RouteEntity.Map),
        },
        {
            path: [RouteEntity.Root, RouteEntity.Coupon],
            title: NavItemTranslateCodes.get(RouteEntity.Coupon),
        },
        {
            path: [RouteEntity.Root, RouteEntity.Topup],
            title: NavItemTranslateCodes.get(RouteEntity.Topup),
        },
        {
            path: [RouteEntity.Root, RouteEntity.Basket],
            title: NavItemTranslateCodes.get(RouteEntity.Basket),
        },
        {
            path: [RouteEntity.Root, RouteEntity.Support],
            title: NavItemTranslateCodes.get(RouteEntity.Support),
        },
        {
            path: [RouteEntity.Root, RouteEntity.PrivacyPolicy],
            title: NavItemTranslateCodes.get(RouteEntity.PrivacyPolicy),
        },
        {
            path: [RouteEntity.Root, RouteEntity.TermsOfUse],
            title: NavItemTranslateCodes.get(RouteEntity.TermsOfUse),
        },
    ];

    constructor(private router: Router) {
    }

    public transitionRouteWithCloseModal(ev: Event, path: string[]): void {
        ev.preventDefault();
        this.router.navigate(path).then(() => {
            this.#dialog.getDialogById(BurgerMenuModalComponent.DIALOG_ID).close();
        });
    }
}
